import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/authContext';
import { UserRoles } from '../types';

interface ProtectedRouteProps {
    children: React.ReactNode;
    requiredRoles?: UserRoles[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
    children,
    requiredRoles = [],
}) => {
    const { getTokenInfo, isGranted } = useAuth();
    const tokenInfo = getTokenInfo();

    // Si l'utilisateur n'est pas connecté, rediriger vers la page de connexion
    if (!tokenInfo) {
        return <Navigate to="/" replace />;
    }

    // Si des rôles sont requis et que l'utilisateur n'a pas les permissions nécessaires
    if (requiredRoles.length > 0 && !isGranted(requiredRoles)) {
        // Rediriger vers une page d'accès refusé ou une autre page appropriée
        return <Navigate to="/access-denied" replace />;
    }

    // Si l'utilisateur est connecté et a les permissions requises, afficher le contenu protégé
    return <>{children}</>;
};

export default ProtectedRoute;
